import {Stack} from "@mui/material";
import {Box, makeStyles, Typography} from "@material-ui/core";
import AddOutlinedIcon from "@mui/icons-material/AddBoxOutlined";
import Grid from "@mui/material/Unstable_Grid2";
import AlertSink from "./AlertSink";
import React from "react";


const useStyles = makeStyles(theme => ({
    outer_div: {
        minHeight: '100vh',
    },
    card: {
        backgroundColor: '#424242',
        color: '#EEEEEE',
    },
    itemBar: {
        display: 'flex',
        flexDirection: 'row',
        backgroundColor: '#222222',
    },
    pageBar: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'flex-end',
        backgroundColor: '#222222',
        color: '#AAAAAA',
    },
    collapsableTableComponent: {
        cursor: 'pointer',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        padding: '10px',
        borderBottom: '1px solid #ccc'
    },
    tableComponent: {
        borderStyle: 'solid',
        borderColor: '#000',
        borderRadius: '10px',
        borderSpacing: '0px',
        borderRightWidth: '1px',
        borderTopWidth: '1px',
        borderBottomWidth: '1px',
        borderLeftWidth: '1px',
        // backgroundColor: '#222222' // setting this breaks row highlighting
    },
    tableCell: {
        paddingLeft: '12px',
        paddingRight: '12px',
        borderBottom: '1px solid #444',
        color: '#CCCCCC',
    },
    clickableTableCell: {
        paddingLeft: '12px',
        borderBottom: '1px solid #444',
        cursor: 'pointer',
    },
    dialog: {
        backgroundColor: '#333333',
        color: '#CCCCCC',
        margin: '10',
    },
    dialogTitleBar: {
        backgroundColor: '#4e54bf',
        color: '#CCCCCC',
    },
    dialogConfirm: {
        backgroundColor: '#149616',
        color: '#CCCCCC',
    },
    dialogNeutral: {
        backgroundColor: '#4e54bf',
        color: '#CCCCCC',
    },
    dialogWarning: {
        backgroundColor: '#d42842',
        color: '#CCCCCC',
    },
    primaryColor: {
        color: '#000',
        backgroundColor: '#111'
    },
    whiteColor: {
        color: "#EEE",
    },
    hide: {
        display: 'none',
    },
    spaced: {
        margin: '10px',
    }
}))

let alert_headers = [
    { field: 'enabled', headerName: 'Enabled', width: 30, hidden: false },
    { field: 'alert_type', headerName: 'Type', width: 100, hidden: false },
    { field: 'target', headerName: 'Target', width: 'auto', hidden: false },
    { field: 'inherited_from', headerName: 'From', width: 50, hidden: false },
    { field: 'send_test', headerName: 'Send Test', width: 40, hidden: false },
    { field: 'edit', headerName: '', width: 30, hidden: false },
    { field: 'delete', headerName: '', width: 30, hidden: false },
]


export default function AlertSinkList({ parent, alert_source, alerts, handleAlertAdd, handleAlertChange, handleAlertInternalChange, handleAlertDelete, requiresSave, setRequiresSave }) {
    const classes = useStyles()

    return (
        <>
            <Stack direction={"row"} justifyContent={"space-between"}>
                <Typography variant='subtitle2' className={classes.dialogWidget} component={'span'}>
                    <em>Note: Alerts are always sent to this Admin Portal</em>
                </Typography>
                <Box>
                    <AddOutlinedIcon className={classes.spaced} color={"primary"}
                                     onClick={() => handleAlertAdd()}/>
                </Box>
            </Stack>
            <Grid container spacing={2}>
                <Grid item xs={2}>
                    <div style={{
                        width: '300px',
                        height: 0,
                        visibility: 'hidden',
                        overflow: 'hidden',
                    }}
                    />
                </Grid>
                <Grid item xs={12}>
                    {/* TABLE */}
                    <table className={classes.tableComponent} style={{width: 100 + "%"}}>
                        <thead>
                        <tr className={classes.tableComponent}>
                            {alert_headers.map(header => (
                                <th key={header.field} width={header.width}
                                    className={header.hidden === true ? classes.hide : ''}>{header.headerName}</th>
                            ))}
                        </tr>
                        </thead>
                        <tbody className={classes.tableComponent}>
                        {alerts && alerts.map((val, index) =>
                            <AlertSink key={index} parent={parent} index={index} alert_source={alert_source} alert_sink={val}
                                       headers={alert_headers} handleAlertChange={handleAlertChange} handleAlertInternalChange={handleAlertInternalChange}
                                       handleAlertDelete={handleAlertDelete} requiresSave={requiresSave} setRequiresSave={setRequiresSave}/>
                        )}
                        </tbody>
                    </table>
                </Grid>
            </Grid>
        </>
    )
}